var NotificationScopeType;
(function (NotificationScopeType) {
    NotificationScopeType["SOURCE"] = "Source";
    NotificationScopeType["SOURCE_GROUP"] = "SourceGroup";
    NotificationScopeType["COMPANY"] = "Company";
})(NotificationScopeType || (NotificationScopeType = {}));
export default NotificationScopeType;
